import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=ba990f3a&scoped=true"
import script from "./accountManagement.vue?vue&type=script&lang=js"
export * from "./accountManagement.vue?vue&type=script&lang=js"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=ba990f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba990f3a",
  null
  
)

export default component.exports